import { TextVariant } from "@/components/ui/text";

export interface TextFormatOption {
  labelKey: string;
  level: number | null;
  descriptionKey: string;
  variant: TextVariant;
}

export const textFormatOptions: TextFormatOption[] = [
  {
    labelKey: "body",
    level: null,
    descriptionKey: "bodyDescription",
    variant: "body" as TextVariant
  },
  {
    labelKey: "heading1",
    level: 1 as const,
    descriptionKey: "heading1Description",
    variant: "lgSubtitle" as TextVariant
  },
  {
    labelKey: "heading2",
    level: 2 as const,
    descriptionKey: "heading2Description",
    variant: "smSubtitle" as TextVariant
  },
  {
    labelKey: "heading3",
    level: 3 as const,
    descriptionKey: "heading3Description",
    variant: "lgLabel" as TextVariant
  }
];

export const getTextFormatLabel = (option: TextFormatOption): string => {
  switch (option.labelKey) {
    case "body":
      return "Aa";
    case "heading1":
      return "H1";
    case "heading2":
      return "H2";
    case "heading3":
      return "H3";
    default:
      return "Aa";
  }
};
